/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ItemQueryResult from './ItemQueryResult';

/**
 * The ItemOutputCmsItems model module.
 * @module model/ItemOutputCmsItems
 * @version 1.0
 */
class ItemOutputCmsItems {
    /**
     * Constructs a new <code>ItemOutputCmsItems</code>.
     * @alias module:model/ItemOutputCmsItems
     */
    constructor() { 
        
        ItemOutputCmsItems.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ItemOutputCmsItems</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemOutputCmsItems} obj Optional instance to populate.
     * @return {module:model/ItemOutputCmsItems} The populated <code>ItemOutputCmsItems</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemOutputCmsItems();

            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [ItemQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/ItemQueryResult>} items
 */
ItemOutputCmsItems.prototype['items'] = undefined;






export default ItemOutputCmsItems;

